export function getHomePageRoute({
  industry = "all",
  topic = "all",
  searchQuery,
}: {
  industry: string | undefined;
  topic: string | undefined;
  searchQuery: string | undefined;
}) {
  const q = searchQuery ? `?q=${searchQuery}` : "";
  if (industry === "all" && topic === "all") {
    if (searchQuery) {
      // When searching do not go to homepage
      return `/search${q}`;
    }
    return `/`;
  }
  if (topic === "all") {
    return `/${industry}${q}`;
  }
  return `/${industry}/${topic}${q}`;
}
